import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  loginItemsSelector,
  setOpenLoginFlow,
  setOpenSignupFlow,
  setOpenVerifyEmailFlow,
  setOpenLookingForFlow,
  setOpenPropertySubCategoryFlow,
  setOpenScheduleVisitFlow,
  setOpenAcknowledgementFlow,
  setOpenAgentLoginFlow,
  setOpenAgentSignupFlow,
} from "../../redux/login";
import LoginDialog from "../Dialog/LoginDialog";
import SignUpDialog from "../Dialog/SignUpDialog";
import ValidateEmail from "../Dialog/ValidateEmail";
import LookingForDialog from "../Dialog/LookingForDialog";
import SelectPropertyDialog from "../Dialog/SelectPropertyDialog";
import ScheduleVisitDialog from "../Dialog/Buy-dashboard-dialog/ScheduleVisitDialog";
import AcknowledgementDialog from "../Dialog/Buy-dashboard-dialog/AcknowledgementDialog";
import AgentLoginDialog from "../Dialog/Agent Login/AgentLoginDialog";
import AgentRegistrationDialog from "../Dialog/Agent Login/AgentRegistrationDialog";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getUserDetailsService } from "../../services/LoginUser";
import Loader from "../loader/Loader";
import { Box, Tooltip, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InfoOutlinedIcon from "@mui/icons-material/Info";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import "../../css/layout.css";

const floatingBtnBase = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
};

const Layout = ({ children, authUser, hideFooter = false }) => {
  const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  let token = searchParams.get("token");
  const [isLoading, setIsLoading] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (location.pathname == "/update-new-password") {
    token = null;
  }
  useEffect(() => {

    if (token) {
      getUserDetails(token);
    }
  }, [token]);

  const getUserDetails = async (token) => {
    try {
      setIsLoading(true);
      let response = await getUserDetailsService(token);
      if (response) {
        dispatch(setOpenLoginFlow(false));
        const redirectRaw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);

        if (redirectRaw) {
          try {
            const { path, state } = JSON.parse(redirectRaw) || {};
            localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

            if (path) {
              if (state) {
                navigate(path, { state });
              } else {
                navigate(path);
              }
            } else {
              navigate("/buy-property");
            }
          } catch (error) {
            console.error("Error parsing post-login redirect:", error);
            navigate("/buy-property");
          }
        } else {
          navigate("/buy-property");
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const {
    openLoginFlow,
    openSignupFlow,
    openVerifyEmail,
    openLookingForFlow,
    openAgentLoginFlow,
    openPropertySubCategoryFlow,
    openAgentSignupFlow,
    openScheduleVisitFlow,
    openAcknowledgementFlow,
  } = useSelector(loginItemsSelector);
  return (
    <>
      <Header authUser={authUser} />
      {children}
      {!hideFooter && <Footer />}
      {isLoading && <Loader />}
      {openLoginFlow && (
        <LoginDialog
          open={openLoginFlow}
          onClose={() => dispatch(setOpenLoginFlow(false))}
        />
      )}
      {openSignupFlow && (
        <SignUpDialog
          open={openSignupFlow}
          onClose={() => dispatch(setOpenSignupFlow(false))}
        />
      )}
      {openVerifyEmail && (
        <ValidateEmail
          open={openVerifyEmail}
          onClose={() => dispatch(setOpenVerifyEmailFlow(false))}
        />
      )}
      {openLookingForFlow && (
        <LookingForDialog
          open={openLookingForFlow}
          onClose={() => dispatch(setOpenLookingForFlow(false))}
        />
      )}
      {openPropertySubCategoryFlow && (
        <SelectPropertyDialog
          open={openPropertySubCategoryFlow}
          onClose={() => dispatch(setOpenPropertySubCategoryFlow(false))}
        />
      )}
      {openScheduleVisitFlow && (
        <ScheduleVisitDialog
          open={openScheduleVisitFlow}
          onClose={() => dispatch(setOpenScheduleVisitFlow(false))}
        />
      )}
      {openAcknowledgementFlow && (
        <AcknowledgementDialog
          open={openAcknowledgementFlow}
          onClose={() => dispatch(setOpenAcknowledgementFlow(false))}
        />
      )}
      {openAgentLoginFlow && (
        <AgentLoginDialog
          open={openAgentLoginFlow}
          onClose={() => dispatch(setOpenAgentLoginFlow(false))}
        />
      )}
      {openAgentSignupFlow && (
        <AgentRegistrationDialog
          open={openAgentSignupFlow}
          onClose={() => dispatch(setOpenAgentSignupFlow(false))}
        />
      )}

      {/* ── Floating action cluster (right side, every page) ── */}
      <Box
        sx={{
          position: "fixed",
          right: { xs: 14, md: 22 },
          bottom: { xs: 20, md: 32 },
          display: "flex",
          flexDirection: "column",
          gap: 1.75,
          zIndex: 1200,
          alignItems: "center",
        }}
      >

        {/* Learn More → /services */}
        <Tooltip title="Learn More" placement="left" arrow>
          <Box
            className="fab-info"
            onClick={() => navigate("/services")}
            sx={{
              ...floatingBtnBase,
              background: "#0085fd",
              color: "#ffffff",
              border: "2px solid #0085fd",
              boxShadow: "0 4px 14px rgba(0,133,253,0.2)",
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
          </Box>
        </Tooltip>

        {/* Contact → /contact */}
        <Tooltip title="Contact Us" placement="left" arrow>
          <Box
            className="fab-contact"
            onClick={() => navigate("/contact")}
            sx={{
              ...floatingBtnBase,
              background: "linear-gradient(135deg, #1a9bff 0%, #0065cc 100%)",
              color: "#ffffff",
              boxShadow: "0 4px 14px rgba(0,133,253,0.35)",
            }}
          >
            <LocalPhoneIcon sx={{ fontSize: 22 }} />
          </Box>
        </Tooltip>
        {/* Back to top — slides in after 300 px scroll */}
        <Zoom in={showBackToTop} unmountOnExit>
          <Tooltip title="Back to top" placement="left" arrow>
            <Box
              className="fab-top"
              onClick={scrollToTop}
              sx={{
                ...floatingBtnBase,
                background: "linear-gradient(135deg, #ffffff 0%, #b3cde756 100%)",
                color: "#0085fd",
                boxShadow: "0 4px 14px rgba(0,133,253,0.35)",
              }}
            >
              <KeyboardArrowUpIcon sx={{ fontSize: 24 }} />
            </Box>
          </Tooltip>
        </Zoom>
      </Box>
    </>
  );
};

export default Layout;
